import { getEcho } from "../../services/echo";
import { getSubdomain } from "../../helpers/domain";

/**
 * Situação das notas em tempo real (BDM-887).
 *
 * Assina o canal do tenant e chama o callback a cada nota que muda. É o
 * ÚNICO caminho automático de atualização (decisão de 15/08: sem polling) —
 * quando o socket ou o webhook falham, quem cobre é a ação manual das telas
 * ("Atualizar" na lista após 1 min; "Verificar agora" no card do pedido).
 * Vale lembrar que o Echo já degradou em silêncio uma vez neste projeto:
 * websocket mudo parece exatamente uma tela sem novidades — os caminhos
 * manuais existem por isso.
 *
 * @param onUpdate ({id, status, order_id}) => void
 * @param onReconnect () => void — re-sincroniza: mudanças ocorridas durante
 *                    uma queda do socket não são reenviadas pelo canal.
 * @returns função de unsubscribe, ou null quando não há websocket
 *          (aí o chamador segue no polling rápido).
 */
export const subscribeFiscalDocuments = (onUpdate, onReconnect) => {
    let echo;

    try {
        echo = getEcho();
    } catch (error) {
        return null;
    }

    if (!echo) {
        return null;
    }

    const channelName = `tenant.${getSubdomain()}.fiscal-documents`;
    let hadConnection = false;

    try {
        echo.private(channelName).listen('.fiscal-document-updated', onUpdate);

        echo.connector?.pusher?.connection?.bind('connected', () => {
            if (hadConnection && typeof onReconnect === 'function') {
                onReconnect();
            }
            hadConnection = true;
        });
    } catch (error) {
        console.error('Falha ao assinar o canal de notas fiscais.', error);
        return null;
    }

    return () => {
        try {
            echo.leave(channelName);
        } catch (error) {
            // A sessão pode ter derrubado o Echo antes do unmount da tela.
        }
    };
};
